module.exports = __webpack_public_path__ + "static/media/cb-sign-up.9baa539a.mp4";